import { render, staticRenderFns } from "./supportChat.vue?vue&type=template&id=066ae583&scoped=true"
import script from "./supportChat.vue?vue&type=script&lang=js"
export * from "./supportChat.vue?vue&type=script&lang=js"
import style0 from "./supportChat.vue?vue&type=style&index=0&id=066ae583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ae583",
  null
  
)

export default component.exports